export default __webpack_public_path__ + "static/media/fitnessIsActive.8edc4d39.svg";